module.exports = "<i class=\"fa fa-spin fa-refresh\"></i> {{ text }}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading-spinner/loading-spinner.component.html
// module id = ./src/app/shared/loading-spinner/loading-spinner.component.html
// module chunks = main